<template>
  <div class="project-detail row" :style="backgroundColor">
    <div class="col-6 pad main">
      <div class="project-info">
        <div class="headline project-title">
          <h3>{{ project.title[$i18n.locale] }}</h3>
        </div>
        <div class="currency">
          <h2 :style="highlightColor">{{ project.value | currency }}</h2>
          <p :style="highlightColor">
            {{ $t('value-generated') }}
          </p>
        </div>
        <div class="project-description">
          <h4>{{ project.description[$i18n.locale] }}</h4>
        </div>
      </div>
      <div class="project-links" v-if="links">
        <Link
          v-for="link in links"
          :key="link.url"
          :palette="project.palette.foreground"
          :link="{
            title: link.name ? link.name : $t('link-cta-default'),
            url: link.url
          }"
        />
      </div>
    </div>
    <div class="col-4">
      <div class="project-image square">
        <img :src="project.image" />
      </div>
    </div>
  </div>
</template>

<script>
import Link from '@/components/common/Link';

export default {
  name: 'Project-Detail',
  components: {
    Link
  },
  props: {
    project: {
      type: Object,
      required: true
    }
  },
  computed: {
    backgroundColor() {
      const col = this.project.palette.background;
      return {
        backgroundColor: col ? col : '#FFFFFF'
      };
    },
    highlightColor() {
      const col = this.project.palette.foreground;
      return {
        color: col ? col : '#FFFFFF'
      };
    },
    links() {
      return this.project.links?.filter( (link) => link.lang ? link.lang==this.$i18n.locale : true )
    }
  }
};
</script>

<style lang="scss" scoped>
.project-detail {
  width: 100%;
  height: 100%;
  overflow-y: scroll;
  background-color: $col-yellow-light;
  color: $col-white;
  .main {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    @media screen and (max-width: $mq-tablet) {
      display: block;
      position: static;
      height: auto;
      justify-content: inherit;
    }
    .project-info {
      @media screen and (max-width: $mq-tablet) {
        margin-bottom: $padding/2;
      }
      .headline,
      .currency {
        margin-bottom: $padding/2;
        @media screen and (max-width: $mq-tablet) {
          margin-bottom: $padding/4;
        }
      }
    }
  }
  .project-links {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: baseline;
    /deep/ .link:not(:last-child) {
      margin-bottom: 1.5rem;
      margin-right: 1.3rem;
    }
  }
  .project-image {
    @media screen and (max-width: $mq-tablet) {
      margin-left: $padding/6;
    }
  }
}
</style>
